import { GOOGLE_RECAPTCHAKEY } from 'utils/constants'

export function createNewCaptchaCode() {
  return window.grecaptcha.execute(GOOGLE_RECAPTCHAKEY, {
    action: '',
  })
}
